import type { ConversationData, ConversationShareableInput, ConversationShareableSuccess } from '@terros/common'
import type { GetHookResponse } from '../hooks'
import { useTantalimQuery } from '../query'
import { conversationShareableKey } from './keys'

export function useConversationShareable(category: string): GetHookResponse<ConversationData[]> {
  return useTantalimQuery<ConversationShareableInput, ConversationShareableSuccess, ConversationData[]>({
    url: '/conversation/shareable',
    queryKey: conversationShareableKey(category),
    input: {
      category,
    },
    convertResponse: (data) => data.conversations,
  })
}
